import { BlipApi } from '../BlipApi';
import { METHOD, RequestStatus } from 'shared/Requests';
import { useSubscriptionReferenceDate } from './BillingApi';
import { DailyEngagedUserUsage } from '../../models/billing/dailyEngagedUsers/DailyEngagedUserUsage';
import { DailyEngagedUsersMonthlyUsage } from '../../models/billing/dailyEngagedUsers/DailyEngagedUsersMonthlyUsage';
import { CompiledDailyEngagedUserConsumption } from '../../models/billing/dailyEngagedUsers/CompiledDailyEngagedUserConsumption';

export default class BillingDailyEngagedUsersServiceApi {
  private readonly BILLING_COMMAND_DESTINATION = 'postmaster@billing.blip.ai';
  private code = '';
  private status = '';
  private useSubscriptionReferenceDate: boolean | undefined = undefined;

  public async getUseSubscriptionReferenceDate(): Promise<void> {
    if (this.useSubscriptionReferenceDate === undefined) {
      this.useSubscriptionReferenceDate = await useSubscriptionReferenceDate();
    }    
  }

  public getStatus() {
    return this.status;
  }

  public getCode() {
    return this.code;
  }

  public setSuccess() {
    this.status = RequestStatus.SUCCESS;
  }

  public setErrorLog(e) {
    const error = JSON.parse(<string>e);
    const {
      status,
      reason: { code },
    } = JSON.parse(error.message);
    this.code = code;
    this.status = status;
    
  }

  public async getCompiledDailyEngagedUserConsumption(
    tenantId: string,
    month: string,
    storageType = 1,
  ): Promise<CompiledDailyEngagedUserConsumption[]> {
    await this.getUseSubscriptionReferenceDate();
    
    const uri =
      `/tenants/${tenantId}/monthly-message-metrics/summary?month=${month}` +
      '&metricIdList=DailyEngagedUser' +
      `&useSubscriptionReferenceDate=${this.useSubscriptionReferenceDate}&storageType=${storageType}`;

    const command = {
      to: this.BILLING_COMMAND_DESTINATION,
      method: METHOD.GET,
      uri: uri,
    };

    try {
      const {
        response: { items },
      } = await BlipApi.sendCommand(command);
      this.setSuccess();
      return items.map((item) => new CompiledDailyEngagedUserConsumption(item));
    } catch (e) {
      this.setErrorLog(e);
      return new Array<CompiledDailyEngagedUserConsumption>(
        new CompiledDailyEngagedUserConsumption(null)
      );
    }
  }

  public async getDailyEngagedUserMonthlyUsage(
    tenantId: string,
    month: string,
    registersToTake: number,
    storageType = 1,
  ): Promise<DailyEngagedUsersMonthlyUsage[] | null> {
    await this.getUseSubscriptionReferenceDate();

    let uri =
    `/tenants/${tenantId}/monthly-message-metrics/monthly/by-bot?month=${month}` +
    '&metricIdList=DailyEngagedUser' +
    `&useSubscriptionReferenceDate=${this.useSubscriptionReferenceDate}` +
    `&storageType=${storageType}`;

    uri = uri + `&$take=${registersToTake}`;

    const command = {
      to: this.BILLING_COMMAND_DESTINATION,
      method: METHOD.GET,
      uri: uri,
    };

    try {
      const {
        response: { items },
      } = await BlipApi.sendCommand(command);
      this.setSuccess();
      return items.map((item) => new DailyEngagedUsersMonthlyUsage(item));
    } catch (e) {
      this.setErrorLog(e);
      return new Array<DailyEngagedUsersMonthlyUsage>();
    }
  }

  public async getDailyEngagedUserUsage(
    tenantId: string,
    month: string,
    registersToTake: number,
    storageType = 1,
  ): Promise<DailyEngagedUserUsage[] | null> {
    await this.getUseSubscriptionReferenceDate();

    let uri =
    `/tenants/${tenantId}/monthly-message-metrics/daily?month=${month}` +
    '&metricIdList=DailyEngagedUser' +
    `&useSubscriptionReferenceDate=${this.useSubscriptionReferenceDate}` +
    `&storageType=${storageType}`;

    uri = uri + `&$take=${registersToTake}`;

    const command = {
      to: this.BILLING_COMMAND_DESTINATION,
      method: METHOD.GET,
      uri: uri,
    };

    try {
      const {
        response: { items },
      } = await BlipApi.sendCommand(command);
      this.setSuccess();
      return items.map((item) => new DailyEngagedUserUsage(item));
    } catch (e) {
      this.setErrorLog(e);
      return new Array<DailyEngagedUserUsage>();
    }
  }

}
